// Leveringskost op de productpagina (snippets/product-delivery-options.liquid).
//
// Levering aan huis is gratis zodra de winkelmand na het toevoegen het bedrag
// voor gratis verzending haalt: de rest van de winkelmand plus dit product maal
// het aantal. De server rekent dat bij het laden uit; dit script houdt het juist
// als de klant een ander aantal of een andere variant kiest, of als de
// winkelmand verandert (iets toegevoegd, of in een ander tabblad).
//
// Regels van dezelfde variant die al in de winkelmand zitten tellen niet mee in
// "de rest": anders telde dit product na het toevoegen dubbel.
(() => {
  const root = document.querySelector('.js-product-delivery-options[data-fee-threshold]');

  if (!root || root.dataset.feeReady) {
    return;
  }

  root.dataset.feeReady = 'true';

  const threshold = parseInt(root.dataset.feeThreshold, 10) || 0;

  if (!threshold) {
    return;
  }

  const form = root.closest('form');
  const wrapper = root.closest('.js-product-info-wrapper') || document;
  const homeInput = root.querySelector('#delivery-home');
  let cart = null;

  const variantId = () => new URLSearchParams(window.location.search).get('variant') || root.dataset.feeVariant;

  // Eenheidsprijs in centen. Na een variantwissel staat de nieuwe prijs in het
  // content-attribuut van .js-product-price (in euro).
  const unitPrice = () => {
    const priceEl = wrapper.querySelector('.js-product-price[content]');
    const euros = priceEl ? parseFloat(priceEl.getAttribute('content')) : NaN;
    return Number.isNaN(euros) ? parseInt(root.dataset.feeUnit, 10) || 0 : Math.round(euros * 100);
  };

  const quantity = () => {
    const input = form ? form.querySelector('.js-quantity-input') : null;
    return Math.max(1, parseInt(input && input.value, 10) || 1);
  };

  const cartOther = () => {
    if (!cart) {
      return null;
    }

    const id = String(variantId());
    return cart.items.reduce(
      (total, item) => (String(item.variant_id) === id ? total - item.final_line_price : total),
      cart.total_price,
    );
  };

  const update = () => {
    const other = cartOther();

    // Zonder winkelmandgegevens (nog niet geladen, of het ophalen mislukte)
    // blijft de toestand van de server staan.
    if (other === null) {
      return;
    }

    const free = other + unitPrice() * quantity() >= threshold;

    // Met leveringskost minder tekst (zie _delivery-choice.scss).
    root.classList.toggle('has-delivery-fee', !free);

    root.querySelectorAll('.js-delivery-fee').forEach((fee) => {
      fee.textContent = free ? fee.dataset.free : fee.dataset.cost;
      fee.classList.toggle('free-label', free);
    });

    root.querySelectorAll('.js-delivery-threshold').forEach((line) => {
      line.hidden = free;
    });

    if (homeInput) {
      homeInput.dataset.label = free ? homeInput.dataset.labelFree : homeInput.dataset.labelCost;
    }
  };

  // Zelfde basis als de winkelmandcode van het thema: "/" of bv. "/fr/".
  const routesRoot = window.theme && window.theme.routes && window.theme.routes.root;
  const cartUrl = `${routesRoot && routesRoot !== '/' ? `${routesRoot}/` : '/'}cart.js`;

  const loadCart = () =>
    fetch(cartUrl, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data && Array.isArray(data.items)) {
          cart = data;
          update();
        }
      })
      .catch(() => {});

  // Het aantal (+/- of typen) en de variant (keuzelijst) veranderen allebei
  // binnen het formulier. Even wachten: de prijs en het aantal worden door
  // andere scripts bijgewerkt op hetzelfde moment.
  const later = () => window.setTimeout(update, 50);

  if (form) {
    form.addEventListener('input', later);
    form.addEventListener('change', later);
    form.addEventListener('click', (event) => {
      if (event.target.closest('.js-quantity-increase, .js-quantity-reduce')) {
        later();
      }
    });
    // Na het toevoegen zit het product in de winkelmand: opnieuw ophalen.
    form.addEventListener('submit', () => window.setTimeout(loadCart, 1500));
  }

  // Terug naar dit tabblad: de winkelmand kan intussen veranderd zijn.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      loadCart();
    }
  });

  loadCart();
})();
